export default __webpack_public_path__ + "static/media/covid-tracker.97cb65d4.png";